import Papa from 'papaparse';

export function downloadCSV<T>(data: T[], fileName: string) {
  const csvContent = Papa.unparse(data);
  const blob = new Blob([csvContent], { type: 'text/csv' });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default downloadCSV;
